{
  "title": "Registration",
  "description": "Use your link below to give parents access to Registration",
  "explanation": {
    "title": "How this link works",
    "body1": "Send this link to parents via email, text or micropost. When selected the link will direct parents to your application via Campanion when installed, or their mobile browser.",
    "body2": "For parents accessing this link in a desktop browser, they will be directed to access Registration in CampInTouch."
  }
}
